import {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useState,
} from "react"

export type PaymentContextType = {
  iframeLink: string
  setIframeLink: Dispatch<SetStateAction<string>>
  paymentSteps: number
  setPaymentSteps: Dispatch<SetStateAction<number>>
}

export const PaymentContext = createContext<PaymentContextType>(null)

export const PaymentContextProvider: FC = ({ children }) => {
  const [iframeLink, setIframeLink] = useState(null)
  const [paymentSteps, setPaymentSteps] = useState(1)

  return (
    <PaymentContext.Provider
      value={{
        iframeLink,
        setIframeLink,
        paymentSteps,
        setPaymentSteps,
      }}
    >
      {children}
    </PaymentContext.Provider>
  )
}

export const usePaymentContext = () => useContext(PaymentContext)
